(() => {
  const script = document.querySelector("script[data-clean-inspection-root]");
  const root =
    script && document.querySelector(script.dataset.cleanInspectionRoot);
  if (!root || root.dataset.cleanInspectionBound) return;

  const isPreview = () => {
    const hostname = window.location.hostname;
    const shopify = window.Shopify;
    const parameters = new URLSearchParams(window.location.search);
    return (
      !["hadiyahgifting.com", "www.hadiyahgifting.com"].includes(hostname) ||
      shopify?.theme?.role !== "main" ||
      shopify.designMode ||
      shopify.visualPreviewMode ||
      parameters.has("preview_theme_id") ||
      parameters.has("preview_key") ||
      document.getElementById("preview-bar-iframe") !== null
    );
  };
  if (isPreview()) return;
  root.dataset.cleanInspectionBound = "true";

  const videos = new Map();
  const protectVideo = (video) => {
    if (!videos.has(video)) {
      videos.set(video, {
        hadAttribute: video.hasAttribute("controlslist"),
        hadNoDownload: (video.getAttribute("controlslist") || "")
          .split(/\s+/)
          .includes("nodownload"),
      });
    }
    const tokens = (video.getAttribute("controlslist") || "")
      .split(/\s+/)
      .filter(Boolean);
    if (!tokens.includes("nodownload")) {
      video.setAttribute("controlslist", [...tokens, "nodownload"].join(" "));
    }
  };
  const restoreVideo = (video) => {
    const original = videos.get(video);
    if (!original) return;
    videos.delete(video);
    if (original.hadNoDownload) return;
    const tokens = (video.getAttribute("controlslist") || "")
      .split(/\s+/)
      .filter((token) => token && token !== "nodownload");
    if (tokens.length || original.hadAttribute) {
      video.setAttribute("controlslist", tokens.join(" "));
    } else {
      video.removeAttribute("controlslist");
    }
  };
  const subtreeVideos = (node) => {
    if (!(node instanceof Element)) return [];
    return [
      ...(node.matches("video") ? [node] : []),
      ...node.querySelectorAll("video"),
    ];
  };
  const guardActive = () => {
    if (isPreview()) {
      root.removeAttribute("data-clean-media-guard");
      for (const video of videos.keys()) restoreVideo(video);
      return false;
    }
    if (!root.hasAttribute("data-clean-media-guard")) {
      root.dataset.cleanMediaGuard = "true";
      root.querySelectorAll("video").forEach(protectVideo);
    }
    return true;
  };
  guardActive();

  // Process changed subtrees only; dialogs and section replacements add media later.
  const observer = new MutationObserver((records) => {
    if (!guardActive()) return;
    for (const record of records) {
      if (record.type === "attributes") {
        if (root.contains(record.target) && record.target.matches("video")) {
          protectVideo(record.target);
        }
        continue;
      }
      for (const node of record.removedNodes) {
        for (const video of subtreeVideos(node)) {
          if (!root.contains(video)) restoreVideo(video);
        }
      }
      for (const node of record.addedNodes) {
        for (const video of subtreeVideos(node)) {
          if (root.contains(video)) protectVideo(video);
        }
      }
    }
  });
  observer.observe(root, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ["controlslist"],
  });

  root.addEventListener("dragstart", (event) => {
    if (!guardActive() || event.defaultPrevented) return;
    const target = event.target instanceof Element ? event.target : null;
    if (
      target?.closest(
        'input, textarea, [contenteditable]:not([contenteditable="false"])',
      )
    )
      return;
    if (
      target?.closest("img, video") ||
      target?.closest("a")?.querySelector("img, video")
    ) {
      event.preventDefault();
    }
  });

  // Keep native editing menus usable for customer details and personalization.
  root.addEventListener("contextmenu", (event) => {
    if (!guardActive()) return;
    const target = event.target instanceof Element ? event.target : null;
    if (
      target?.closest(
        'input, textarea, [contenteditable]:not([contenteditable="false"])',
      )
    )
      return;
    event.preventDefault();
  });

  root.addEventListener("keydown", (event) => {
    if (!guardActive() || event.defaultPrevented) return;
    const key = event.key.toLowerCase();
    const windowsTools =
      event.ctrlKey && event.shiftKey && !event.altKey && !event.metaKey;
    const macTools =
      event.metaKey && event.altKey && !event.ctrlKey && !event.shiftKey;
    const developerShortcut =
      key === "f12" ||
      ((windowsTools || macTools) && ["i", "j", "c"].includes(key)) ||
      (event.ctrlKey &&
        !event.shiftKey &&
        !event.altKey &&
        !event.metaKey &&
        key === "u") ||
      (macTools && key === "u");
    if (developerShortcut) event.preventDefault();
  });
})();
